module.exports = __webpack_public_path__ + "src/assets/images/accident-management/icon-notifications.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accident-management/icon-notifications.jpg
// module id = 2311
// module chunks = 4